import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'
import { TERMINAL_TYPE } from "../api/enums.js"

const ONLINE_STATUS_REFRESH_INTERVAL = 30000;

export default defineStore('friendStore', {
	state: () => {
		return {
			friends: [], // 好友列表
			timer: null
		}
	},
	actions: {
		setFriends(friends) {
			const currentFriends = new Map(
				this.friends.map((friend) => [String(friend.id), friend])
			);
			this.friends = (friends || []).map((friend) => {
				const currentFriend = currentFriends.get(String(friend.id));
				const hasTerminalStatus = typeof friend.onlineWeb !== 'undefined'
					|| typeof friend.onlineApp !== 'undefined';
				if (hasTerminalStatus) {
					friend.onlineWeb = !!friend.onlineWeb;
					friend.onlineApp = !!friend.onlineApp;
					friend.online = !!(friend.onlineWeb || friend.onlineApp);
				} else if (typeof friend.online !== 'undefined') {
					friend.online = !!friend.online;
					friend.onlineWeb = currentFriend ? !!currentFriend.onlineWeb : false;
					friend.onlineApp = currentFriend ? !!currentFriend.onlineApp : false;
				} else {
					friend.online = currentFriend ? !!currentFriend.online : false;
					friend.onlineWeb = currentFriend ? !!currentFriend.onlineWeb : false;
					friend.onlineApp = currentFriend ? !!currentFriend.onlineApp : false;
				}
				return friend;
			});
		},
		updateFriend(friend) {
			this.friends.forEach((f, index) => {
				if (f.id == friend.id) {
					// 拷贝属性，同时保留并更新在线状态字段
					let old = this.friends[index];
					Object.assign(old, friend);
					// 统一根据 onlineWeb / onlineApp 计算 online
					if (typeof old.onlineWeb !== 'undefined' || typeof old.onlineApp !== 'undefined') {
						old.online = !!(old.onlineWeb || old.onlineApp);
					}
				}
			})
		},
		removeFriend(id) {
			this.friends.filter(f => f.id == id).forEach(f => f.deleted = true);
		},
		addFriend(friend) {
			if (this.friends.some(f => f.id == friend.id)) {
				this.updateFriend(friend)
			} else {
				this.friends.unshift(friend);
			}
		},
		updateOnlineStatus(onlineData) {
			let friend = this.findFriend(onlineData.userId);
			if (!friend) {
				return;
			}
			if (onlineData.terminal == TERMINAL_TYPE.WEB) {
				friend.onlineWeb = !!onlineData.online;
			} else if (onlineData.terminal == TERMINAL_TYPE.APP) {
				friend.onlineApp = !!onlineData.online;
			}
			friend.online = !!(friend.onlineWeb || friend.onlineApp);
		},
		setOnlineStatus(onlineTerminals) {
			const terminalMap = new Map(
				(onlineTerminals || []).map((item) => [String(item.userId), item.terminals || []])
			);
			this.friends.forEach((friend) => {
				const terminals = terminalMap.get(String(friend.id)) || [];
				friend.onlineWeb = terminals.indexOf(TERMINAL_TYPE.WEB) >= 0;
				friend.onlineApp = terminals.indexOf(TERMINAL_TYPE.APP) >= 0;
				friend.online = !!(friend.onlineWeb || friend.onlineApp);
			});
		},
		refreshOnlineStatus() {
			this.timer && clearTimeout(this.timer);
			this.timer = null;
			const userIds = this.friends.filter((friend) => !friend.deleted).map((friend) => friend.id);
			if (!userIds.length) {
				return Promise.resolve([]);
			}
			return http({
				url: '/user/terminal/online?userIds=' + userIds.join(','),
				method: 'GET'
			}).then((onlineTerminals) => {
				this.setOnlineStatus(onlineTerminals);
				return onlineTerminals;
			}).catch((error) => {
				console.warn('刷新好友在线状态失败:', error);
				return [];
			}).finally(() => {
				if (this.friends.length) {
					this.timer && clearTimeout(this.timer);
					this.timer = setTimeout(() => {
						this.refreshOnlineStatus();
					}, ONLINE_STATUS_REFRESH_INTERVAL);
				}
			});
		},
		clear() {
			this.timer && clearTimeout(this.timer);
			this.friends = [];
			this.timer = null;
		},
		loadFriend() {
			return new Promise((resolve, reject) => {
				http({
					url: '/friend/list',
					method: 'GET'
				}).then(async (friends) => {
					this.setFriends(friends);
					this.refreshOnlineStatus();
					resolve();
				}).catch(e => {
					reject(e);
				})
			});
		}
	},
	getters: {
		isFriend: (state) => (userId) => {
			return state.friends.filter((f) => !f.deleted).some((f) => f.id == userId);
		},
		findFriend: (state) => (userId) => {
			return state.friends.find((f) => f.id == userId);
		}
	}
});
